import type { JsonDataItem } from '../types';
import { forceAssert } from '../utils';
import type { VisibilityConditionValueTypes } from './converters/target-value/i-target-value-converter';
import type { VisibilityCondition } from './visibility-condition.interfaces';
import { VisibilityConditionBase } from './visibility-condition-base';

interface HierarchyValue {
  id: number;
  hierarchyTypeId: number;
  caption: string;
  longitude: number;
  latitude: number;
  geofenceEnabled: boolean;
  archived: boolean;
  lastChanged: Date | string;
  parentId?: number;
  dependsOnParent?: boolean;
  external?: boolean;
}

export class HierarchyVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    let isHidden = this.defaultIsHidden;
    if (this.fieldCondition.sourceFieldName) {
      isHidden = this.determineIsHidden(
        forceAssert<Record<string, HierarchyValue>>(
          currentData['hierarchyValues'],
        )?.[this.fieldCondition.sourceFieldName]?.caption,
        this.fieldCondition.targetValue as VisibilityConditionValueTypes,
        this.fieldCondition.negation,
      );
    }

    return isHidden;
  }
}
